import { render } from "./participantsDropdown.vue?vue&type=template&id=b918001c&scoped=true"
import script from "./participantsDropdown.vue?vue&type=script&lang=js"
export * from "./participantsDropdown.vue?vue&type=script&lang=js"

import "./participantsDropdown.vue?vue&type=style&index=0&id=b918001c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b918001c"]])

export default __exports__